import React from 'react';
import { CiCircleInfo } from 'react-icons/ci';
import css from './InfoLabel.module.css';

const InfoLabel = ({ label, infoText, ariaLabel = 'More information' }) => {
  return (
    <span className={css.labelRow}>
      <span>{label}</span>

      <span className={css.infoWrap} tabIndex={0} aria-label={ariaLabel}>
        <CiCircleInfo className={css.infoIcon} aria-hidden="true" />
        <span className={css.tooltip} role="tooltip">
          {infoText}
        </span>
      </span>
    </span>
  );
};

export default InfoLabel;
